import { FileImage, FileText, File, FileCode, FileSpreadsheet } from "lucide-react";
import { LucideIcon } from "lucide-react";

export function getFileIcon(fileType: string): LucideIcon {
  const type = fileType.toLowerCase();
  
  if (type.includes('image') || type.match(/\.(jpg|jpeg|png|gif|webp|svg)$/)) {
    return FileImage;
  }
  if (type.includes('text') || type.match(/\.(txt|md|markdown)$/)) {
    return FileText;
  }
  if (type.match(/\.(js|jsx|ts|tsx|py|java|cpp|c|html|css)$/)) {
    return FileCode;
  }
  if (type.match(/\.(xls|xlsx|csv)$/)) {
    return FileSpreadsheet;
  }
  
  return File;
}

export function getFileType(file: File): 'image' | 'pdf' | 'document' | 'text' | 'other' {
  const type = file.type.toLowerCase();
  const name = file.name.toLowerCase();
  
  if (type.startsWith('image/')) return 'image';
  if (type === 'application/pdf' || name.endsWith('.pdf')) return 'pdf';
  if (type.startsWith('text/') || name.match(/\.(txt|md|markdown)$/)) return 'text';
  if (name.match(/\.(doc|docx|odt|rtf)$/)) return 'document';
  
  return 'other';
}

export async function readFileAsDataUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export async function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsText(file);
  });
}

export function formatFileSize(bytes: number): string {
  if (bytes === 0) return '0 B';
  const k = 1024;
  const sizes = ['B', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
}
